export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("zh-CN", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const formatTime = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleTimeString("zh-CN", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatExperienceDate = (startDate, endDate) => {
  const start = startDate ? startDate : "?";
  const end = endDate
    ? endDate.toLowerCase() === "present"
      ? "至今"
      : endDate
    : "?";
  return `${start} - ${end}`;
}
